'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _loginCookieUtils = require('./loginCookieUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
  var adjustedPath = path[0] !== '/' ? '/' + path : path;
  if (__SERVER__) {
    // Prepend host and port of the API server to the path.
    return 'http://' + _config2.default.apiHost + ':' + _config2.default.apiPort + adjustedPath;
  }
  // Prepend `/api` to relative URL, to proxy to API server.
  return '/api' + adjustedPath;
}

/*
 * This silly underscore is here to avoid a mysterious "ReferenceError: ApiClient is not defined" error.
 * See Issue #14. https://github.com/erikras/react-redux-universal-hot-example/issues/14
 *
 * Remove it at your own risk.
 */

var ApiClient = function () {
  function ApiClient(req) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ApiClient);

    methods.forEach(function (method) {
      return _this[method] = function (path) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            params = _ref.params,
            data = _ref.data;

        return new _promise2.default(function (resolve, reject) {
          var createRequest = function createRequest() {
            var url = formatUrl(path);
            console.log('CALLING API URL ' + url);
            var request = _superagent2.default[method](url);
            if (params) {
              request.query(params);
            }

            if (__SERVER__ && req && req.get('cookie')) {
              request.set('cookie', req.get('cookie'));
            }

            if (data) {
              request.send(data);
            }

            if (!__SERVER__ && window.agamaToken) {
              request.set('currenttoken', window.agamaToken);
            }

            return request;
          };
          var request = createRequest();
          request.end(function (err) {
            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                body = _ref2.body;

            if (err) {
              // pokud obdrzime ze serveru 403, provedeme prilogovani (uzivatel napřiklad zmenil polohu a tim padem IP adresu)
              // a pak posleme data znovu
              if (err.status === 403) {
                var serviceName = (0, _loginCookieUtils.getServiceName)(); // nacteme cookie udavajici jmeno aktualní sluzby pro logovani
                if (serviceName) {
                  var loginFunction = window.agamaLogins[serviceName];
                  var cb = function cb(idToken) {
                    var authRequest = _superagent2.default.post(formatUrl('reauthentify'));
                    authRequest.set('servicetoken', idToken);
                    authRequest.set('currenttoken', window.agamaToken);
                    authRequest.set('servicename', serviceName);
                    authRequest.send({});
                    authRequest.end(function (err2, res2) {
                      if (err2) {
                        console.log('Reconect function has failed. Showing error.');
                        reject(err2);
                      } else {
                        window.agamaToken = res2.body; // nove ziskaný token
                        var requestAgain = createRequest();
                        console.log('Recalling after reconnecting');
                        requestAgain.end(function (err3) {
                          var res3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                          if (err3) reject(err3);else resolve(res3.body);
                        });
                      }
                    });
                  };
                  if (loginFunction) loginFunction(cb);else {
                    // nelze zavolat loginovací funkci
                    console.log('Reconect function does not exists. Showing error.');
                    reject(body || err);
                  }
                  return;
                }
                // serviceName not found:
                reject((0, _extends3.default)({}, err, { priorityMessage: 'Please login to continue ' }));
                return;
              }
              if (err && err.status === 406) {
                reject((0, _extends3.default)({}, err, { priorityMessage: body && body.message || err.message || 'Unknown error' }));
                return;
              }
              reject(body || err);
            } else resolve(body);
          });
        });
      };
    });
  }

  /* VLADKA: ZKOIPIROVANO Z https://github.com/erikras/react-redux-universal-hot-example/commit/721a16264eb9203b195cbf1a50e17a3bab6edbc8
  * There's a V8 bug where, when using Babel, exporting classes with only
  * constructors sometimes fails. Until it's patched, this is a solution to
  * "ApiClient is not defined" from issue #14.
  * https://github.com/erikras/react-redux-universal-hot-example/issues/14
  *
  * Relevant Babel bug (but they claim it's V8): https://phabricator.babeljs.io/T2455
  *
  * Remove it at your own risk.
  */


  (0, _createClass3.default)(ApiClient, [{
    key: 'empty',
    value: function empty() {}
  }]);
  return ApiClient;
}();

//let ApiClient = ApiClientX

//export default ApiClient;


exports.default = ApiClient;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/ApiClient.js
// module id = 1216
// module chunks = 0